<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
// eslint-disable-next-line vue/multi-word-component-names
  name: "App",
  data() {
    return {
    };
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'Easy Remove'
    };
  },
    mounted() {
    this.apc();
  },
  methods: {
    //判断是手机还是电脑
    apc(){
      //为空是电脑 不为空是手机
      if (this.$router.history._startLocation==="/Order"){
        if (this._isMobile()){
          this.$router.push(`/Order`)
        }else {
          this.$router.push(`/tishi`)
        }
      }else if (this.$router.history._startLocation==="/saoyisao"){
        if (this._isMobile()){
          this.$router.push(`/saoyisao`)
        }else {
          this.$router.push(`/tishi`)
        }
      }
    },
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #2c3e50;

}
//body{
//  background-color: #ededed;
//}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
